<div class="login-help-page">
  <h2>Login Help</h2>

  <h4>Forgot Password</h4>
  <p class="pad-left">
    If you have forgotten your password contact engineering to have it reset. Passwords are managed externally and are not stored in the portal.
  </p>

  <h4>Can't use Authenticator</h4>
  <p class="pad-left">
    If you have a new phone and you didn't transfer your Authenticator app accounts, or if you are having trouble with MFA, contact engineering for assistance. We can temporarily disable MFA for your account to allow you to login and set up the Authenticator app again.
  </p>

  <h4>How to login</h4>
  <ol>
    <li>Open the portal and click the <strong>Login</strong> button in the top-right corner.</li>
    <li>When prompted, sign in with your organization Microsoft account.</li>
    <li>Complete any required MFA verification.</li>
    <li>After successful sign-in, return to the portal and select the required area (Service, Stock, Assets, Units).</li>
  </ol>

  <h4>First Login Walkthrough Video</h4>
  <p class="pad-left">
    If this is your first time logging in, or if you would like a walkthrough of the login process, watch the video below. It demonstrates the login process from start to finish, including signing in with Microsoft and setting up the Authenticator app for MFA.
  </p>

  <video *ngIf="videoUrl" class="login-help-video" controls preload="metadata" [src]="videoUrl">
    Your browser does not support HTML5 video.
  </video>

</div>
